import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Line } from 'react-chartjs-2';
import * as actions from '../../actions';
import moment from 'moment';

class LineChart extends Component {
  constructor(props) {
    super(props);
    this.getData = this.getData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const sitePage = nextProps.selectedPage;
    const metric = nextProps.selectedMetric;
    const queryPage = nextProps.selectedQuery;

    const { fetchPageMetricsByDate, fetchQueryMetricsByDate } = this.props;

    const { startDate, endDate, country, device } = nextProps;

    const diffStartDate    = startDate !== this.props.startDate;
    const diffEndDate      = endDate   !== this.props.endDate;
    const diffSitePage     = sitePage  !== this.props.selectedPage;
    const diffQueryPage    = queryPage !== this.props.selectedQuery;
    const diffCountry      = country   !== this.props.country;
    const diffDevice       = device    !== this.props.device;

    // Don't run if dates are invalid i.e. endDate is before startDate
    if (endDate < startDate) {
      return;
    }

    const differentMetrics = diffCountry   ||
                             diffDevice    ||
                             diffStartDate ||
                             diffEndDate   ||
                             diffStartDate ||
                             diffSitePage

    if (!this.props.startDate || !this.props.endDate) return;
    if (differentMetrics && sitePage === '') return;

    if (differentMetrics) {
      fetchPageMetricsByDate({
        startDate,
        endDate,
        sitePage,
        metric,
        country,
        device
      });

      fetchQueryMetricsByDate({
        startDate,
        endDate,
        sitePage,
        metric,
        country,
        queryPage,
        device
      });
    }

    // When queryPage is blank remove query line chart
    if (queryPage === '' && diffQueryPage) {
      fetchQueryMetricsByDate();
    }

    // Change query line chart when queryPage is selected and doesn't go null / empty
    if (queryPage !== '' && diffQueryPage)  {
      fetchQueryMetricsByDate({
        startDate,
        endDate,
        sitePage,
        metric,
        country,
        queryPage,
        device
      });
    }
  }

  getData() {
    const {
      pageMetricsByDate,
      selectedMetric,
      queryMetricsByDate,
      selectedPage,
      selectedQuery
    } = this.props;

    if (!pageMetricsByDate || !selectedMetric) return;

    const labels = pageMetricsByDate.map(obj =>
      moment(obj.keys[0]).format('MMM D')
    );

    const metricPageData = pageMetricsByDate.map(dataByMetric);
    const metricQueryData = queryMetricsByDate.map(dataByMetric);

    function dataByMetric(obj) {
      switch (selectedMetric) {
        case 'clicks':
          return obj.clicks;
        case 'impressions':
          return obj.impressions;
        case 'ctr':
          return (obj.ctr * 100).toFixed(2);
        case 'position':
          return obj.position.toFixed(2);
        default:
          return obj.clicks;
      }
    }

    let pageDataSet = {
      label: selectedPage,
      fill: false,
      lineTension: 0,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(75,192,192,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 5,
      data: metricPageData
    };

    let queryDataSet = {
      label: selectedQuery,
      borderColor: '#ee6e73',
      borderCapStyle: 'butt',
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: '#ee6e73',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: '#ee6e73',
      pointHoverBorderColor: '#ee6e73',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 5,
      data: metricQueryData,
      fill: false,
      lineTension: 0.1
    };

    let datasets;
    if (selectedQuery && selectedPage) {
      datasets = [pageDataSet, queryDataSet];
    } else if (selectedPage) {
      datasets = [pageDataSet];
    } else {
      datasets = [queryDataSet];
    }

    return { labels, datasets };
  }

  render() {
    const data = this.getData();
    const options = {
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            }
          }
        ]
      },
      tooltips: {
        mode: 'x-axis'
      },
      layout: {
        padding: {
          left: 10
        }
      }
    };

    return (
      <div>
        <Line data={data} width={1200} height={300} options={options} />
      </div>
    );
  }
}

function mapStateToProps({
  pageMetricsByDate,
  selectedMetric,
  selectedPage,
  queryMetricsByDate,
  selectedQuery,
  queries,
  country,
  startDate,
  endDate,
  device
}) {
  return {
    pageMetricsByDate,
    selectedMetric,
    selectedPage,
    queryMetricsByDate,
    selectedQuery,
    queries,
    country,
    startDate,
    endDate,
    device
  };
}

export default connect(mapStateToProps, actions)(LineChart);



// WEBPACK FOOTER //
// ./src/components/Dashboard/LineChart.js